import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/flaticon/010-fairytale.svg'
import _imports_1 from '../assets/img/flaticon/034-list.svg'
import _imports_2 from '../assets/img/flaticon/036-application.svg'


const _withScopeId = n => (_pushScopeId("data-v-c721d84c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container p-0 m-0 .fondoArriba .fondoAbajo",
  "data-kt-landing": "true"
}
const _hoisted_2 = {
  key: 0,
  class: "divBlanco textoCentrado p-5 pb-2"
}
const _hoisted_3 = { class: "fs-4 landingSubtitle2 m-3" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divBlanco" }, null, -1))
const _hoisted_6 = { class: "row imgHomePage" }
const _hoisted_7 = { class: "m-0 homeInfo align-content-center" }
const _hoisted_8 = { class: "landingInfoTextTitle d-flex pb-5 pr-5 text-center" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icono fas fa-info-circle fa-2x" }, null, -1))
const _hoisted_10 = { class: "align-self-center colorTitle" }
const _hoisted_11 = { class: "landingInfoText" }
const _hoisted_12 = { class: "landingInfoText recuadro" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divBlanco mb-5" }, null, -1))
const _hoisted_14 = {
  key: 0,
  class: "acciones fondoArriba m-0 p-0"
}
const _hoisted_15 = { class: "row justity-content-center m-0 p-0" }
const _hoisted_16 = { class: "row textoCentrado mt-5 mb-5" }
const _hoisted_17 = { class: "colorTitle p-0 fs-5" }
const _hoisted_18 = { class: "landingSubtitle" }
const _hoisted_19 = { class: "landingSubtitle2 cajaTexto fs-2 mt-5" }
const _hoisted_20 = { class: "row d-flex gap-5 justify-content-around p-0 my-5 ms-2" }
const _hoisted_21 = {
  class: "col-12 col-md-4 card textoCentrado me-3 tarjeta imgColectivos",
  style: {"background-color":"#6700ed52"}
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cardIcono m-5",
  src: _imports_0,
  alt: "Actividades"
}, null, -1))
const _hoisted_23 = { class: "mt-4" }
const _hoisted_24 = { class: "card-body" }
const _hoisted_25 = { class: "card-title" }
const _hoisted_26 = {
  class: "col-12 col-md-4 card textoCentrado me-3 tarjeta imgGeneral",
  style: {"background-color":"#6700ed52"}
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cardIcono m-5",
  src: _imports_1,
  alt: "Actividades"
}, null, -1))
const _hoisted_28 = { class: "mt-4" }
const _hoisted_29 = { class: "card-body" }
const _hoisted_30 = { class: "card-title" }
const _hoisted_31 = {
  class: "col-12 col-md-4 card textoCentrado me-3 tarjeta imgProfesionales",
  style: {"background-color":"#02b59749"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "cardIcono m-5",
  src: _imports_2,
  alt: "Actividades"
}, null, -1))
const _hoisted_33 = { class: "mt-4" }
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = { class: "card-title" }
const _hoisted_36 = { class: "divAccesoFamilias textoCentrado" }
const _hoisted_37 = { class: "landingSubtitle pt-5" }
const _hoisted_38 = { class: "landingSubtitle2 pb-5" }
const _hoisted_39 = { class: "textoCentrado mt-5" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-unlock fs-2 me-2 mb-1" }, null, -1))
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "card detalleServicio sombra" }
const _hoisted_43 = { class: "landingSubtitle pt-6 mt-5 fw-bold text-center" }
const _hoisted_44 = { class: "divServicio1 row justify-content-center text-center" }
const _hoisted_45 = { class: "iconoServ2 d-flex" }
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "col-12 col-md-6 col-sm-6 align-self-center" }
const _hoisted_48 = { class: "label" }
const _hoisted_49 = { style: {"font-weight":"500"} }
const _hoisted_50 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_52 = { class: "col-12 col-md-6 col-sm-6 align-self-center" }
const _hoisted_53 = { class: "label" }
const _hoisted_54 = { style: {"font-weight":"500"} }
const _hoisted_55 = /*#__PURE__*/_createTextVNode(": ")
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_57 = ["innerHTML"]
const _hoisted_58 = { class: "divServicio2" }
const _hoisted_59 = { class: "d-flex justify-content-center izquierda" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-map-marker-alt fs-3x text-center icono" }, null, -1))
const _hoisted_61 = { class: "align-self-center colorTitle" }
const _hoisted_62 = { class: "landingSubtitle" }
const _hoisted_63 = { class: "d-flex justify-content-center izquierda mt-5" }
const _hoisted_64 = ["innerHTML"]
const _hoisted_65 = { class: "label" }
const _hoisted_66 = { class: "landingSubtitle mb-5" }
const _hoisted_67 = {
  key: 0,
  class: "label textoJustificado fs-5",
  style: {"white-space":"pre-line"}
}
const _hoisted_68 = {
  key: 1,
  class: "label textoJustificado fs-5",
  style: {"white-space":"pre-line"}
}
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_71 = {
  class: "label textoJustificado fs-5",
  style: {"white-space":"pre-line"}
}
const _hoisted_72 = { class: "py-9" }
const _hoisted_73 = {
  key: 0,
  class: "row mb-6"
}
const _hoisted_74 = { class: "col-lg-12 fv-row text-start" }
const _hoisted_75 = { class: "el-upload-list el-upload-list--text" }
const _hoisted_76 = { class: "fv-row fv-plugins-icon-container d-inline-block align-middle" }
const _hoisted_77 = ["onClick", "href"]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"center","align-items":"center","width":"100%","height":"100%","background":"#f5f7fa","color":"#be99ee","font-size":"10px"} }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "90",
    height: "90",
    fill: "currentColor",
    class: "bi bi-filetype-pdf",
    viewBox: "0 0 16 16"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M14 4.5V14a2 2 0 0 1-2 2h-1v-1h1a1 1 0 0 0 1-1V4.5h-2A1.5 1.5 0 0 1 9.5 3V1H4a1 1 0 0 0-1 1v9H2V2a2 2 0 0 1 2-2h5.5L14 4.5ZM1.6 11.85H0v3.999h.791v-1.342h.803c.287 0 .531-.057.732-.173.203-.117.358-.275.463-.474a1.42 1.42 0 0 0 .161-.677c0-.25-.053-.476-.158-.677a1.176 1.176 0 0 0-.46-.477c-.2-.12-.443-.179-.732-.179Zm.545 1.333a.795.795 0 0 1-.085.38.574.574 0 0 1-.238.241.794.794 0 0 1-.375.082H.788V12.48h.66c.218 0 .389.06.512.181.123.122.185.296.185.522Zm1.217-1.333v3.999h1.46c.401 0 .734-.08.998-.237a1.45 1.45 0 0 0 .595-.689c.13-.3.196-.662.196-1.084 0-.42-.065-.778-.196-1.075a1.426 1.426 0 0 0-.589-.68c-.264-.156-.599-.234-1.005-.234H3.362Zm.791.645h.563c.248 0 .45.05.609.152a.89.89 0 0 1 .354.454c.079.201.118.452.118.753a2.3 2.3 0 0 1-.068.592 1.14 1.14 0 0 1-.196.422.8.8 0 0 1-.334.252 1.298 1.298 0 0 1-.483.082h-.563v-2.707Zm3.743 1.763v1.591h-.79V11.85h2.548v.653H7.896v1.117h1.606v.638H7.896Z"
    })
  ])
], -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = { class: "mr-2 mb-2 pt-5 text-end" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "modal fade",
  id: "documentoModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "documentoModalLabel",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "modal-dialog modal-lg",
    role: "document"
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "modal-body" }, [
        /*#__PURE__*/_createElementVNode("img", {
          id: "imagenCompleta",
          src: "",
          class: "img-fluid"
        })
      ])
    ])
  ])
], -1))
const _hoisted_82 = { key: 2 }
const _hoisted_83 = { class: "landingSubtitle pt-6 m-10" }
const _hoisted_84 = {
  key: 3,
  class: "container p-0 m-0",
  "data-kt-landing": "true"
}
const _hoisted_85 = {
  class: "row imgHomePage",
  ref: "info"
}
const _hoisted_86 = { class: "m-0 homeInfo align-content-center" }
const _hoisted_87 = { class: "landingInfoTextTitle d-flex pb-5 pr-5 text-center" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icono fas fa-info-circle fa-2x" }, null, -1))
const _hoisted_89 = { class: "align-self-center colorTitle" }
const _hoisted_90 = { class: "landingInfoText" }
const _hoisted_91 = { class: "landingInfoText recuadro" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_image = _resolveComponent("el-image")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.inscripcionesAbiertas)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.i18n("infoVerMas")), 1),
            _createElementVNode("p", null, [
              _createElementVNode("a", {
                class: "cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.scrollTo('info')))
              }, _toDisplayString(_ctx.i18n("masLink")), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.inscripcionesAbiertas && !_ctx.token)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h3", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.i18n("informacionGeneral")), 1)
                ]),
                _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.i18n("planCorresponsablesInfo")), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.i18n("planCorresponsablesObjetivos")), 1)
              ])
            ]),
            _hoisted_13
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.token)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.i18n("planCorresponsablesInscrip")), 1),
              _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.i18n("planCorresponsablesRegistro")), 1),
              _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.i18n("planCorresponsablesRegistroDesc")), 1)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_router_link, {
                  to: "/servicios-colectivos",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.i18n("cardFamilias")), 1),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("h5", _hoisted_25, _toDisplayString(_ctx.i18n("solicitudServiciosColectivosFamiliasBtn")), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createVNode(_component_router_link, {
                  to: "/familias",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.i18n("cardFamilias")), 1),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("h5", _hoisted_30, _toDisplayString(_ctx.i18n("solicitudFamiliasTitulo")), 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_component_router_link, {
                  to: "/profesionales",
                  "active-class": "active"
                }, {
                  default: _withCtx(() => [
                    _hoisted_32,
                    _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.i18n("cardProfesionales")), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("h5", _hoisted_35, _toDisplayString(_ctx.i18n("solicitudProfesionalesTitulo")), 1)
                    ])
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("h3", _hoisted_37, _toDisplayString(_ctx.i18n("accesoFamiliasTitulo")), 1),
            _createElementVNode("h3", _hoisted_38, _toDisplayString(_ctx.i18n("accesoFamiliasTexto")), 1),
            _createElementVNode("div", _hoisted_39, [
              _createVNode(_component_router_link, {
                to: "/acceso-familias",
                class: "btn btn-info botonFormSecondary m-1 p-5",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _hoisted_40,
                  _createTextVNode(" " + _toDisplayString(_ctx.i18n("accesoFamiliasBtn")), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.token && _ctx.inscripcionesAbiertas)
      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("h3", _hoisted_43, _toDisplayString(_ctx.nombre), 1),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("img", {
                  src: 
              '/media/iconos-servicios/' +
              (_ctx.iconoCls
                ? _ctx.iconoCls.replace(/\s+/g, '-') + '.png'
                : 'default.png')
            ,
                  alt: "{{iconoCls}}"
                }, null, 8, _hoisted_46)
              ]),
              _createElementVNode("div", _hoisted_47, [
                _createElementVNode("div", _hoisted_48, [
                  _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.$t("servicioProgramado.plazas.label")), 1),
                  _hoisted_50,
                  _hoisted_51,
                  _createTextVNode(_toDisplayString(_ctx.plazas), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.$t("servicioProgramado.fecha.label")), 1),
                  _hoisted_55,
                  _hoisted_56,
                  _createElementVNode("div", {
                    class: "fs-7",
                    innerHTML: 
                _ctx.$t('servicioProgramado.fechas.label', {
                  inicioPrevistoFormateado: _ctx.inicioPrevistoFormateado + '<br>',
                  finPrevistoFormateado: _ctx.finPrevistoFormateado,
                })
              
                  }, null, 8, _hoisted_57)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, [
                  _createElementVNode("h4", _hoisted_62, _toDisplayString(_ctx.$t("servicioProgramado.donde.label")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_63, [
                (_ctx.lugarEspacioColectivo == 'OTROS')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: "label",
                      innerHTML: _ctx.otrosEspacioColectivo + ' - '
                    }, null, 8, _hoisted_64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_65, _toDisplayString(_ctx.direccion), 1)
              ])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_66, _toDisplayString(_ctx.$t("ServiciosInfo")), 1),
              (!_ctx.usarCalendarioServicio)
                ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("servicioProgramado.diasSemana.label")), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.diasSemanaTexto), 1)
                  ]))
                : _createCommentVNode("", true),
              (!_ctx.usarCalendarioServicio)
                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t("servicioProgramado.horario.label")), 1),
                    _createTextVNode(" " + _toDisplayString(_ctx.horarioLibre) + " ", 1),
                    _hoisted_69,
                    _hoisted_70
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_71, _toDisplayString(_ctx.descripcion), 1)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_72, [
                (_ctx.documentos.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("ul", _hoisted_75, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documentos, (file, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: i,
                              tabindex: "0"
                            }, [
                              _createElementVNode("div", _hoisted_76, [
                                _createElementVNode("a", {
                                  class: "el-upload-list__item-name",
                                  onClick: ($event: any) => (_ctx.onImagenClick(file.blob, file.nombre)),
                                  href: file.blob
                                }, [
                                  _createVNode(_component_el_image, {
                                    class: "align-middle",
                                    style: {"width":"120px","height":"120px","border-radius":"20px"},
                                    src: file.blob,
                                    fit: "cover"
                                  }, {
                                    error: _withCtx(() => [
                                      _hoisted_78
                                    ]),
                                    _: 2
                                  }, 1032, ["src"]),
                                  _hoisted_79,
                                  _createTextVNode(" " + _toDisplayString(file.nombre), 1)
                                ], 8, _hoisted_77)
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_80, [
                    _createVNode(_component_router_link, {
                      to: _ctx.nextStepUrl,
                      class: "btn btn-lg btn-primary botonFormSecondary2 sombra",
                      "active-class": "active"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t("servicioProgramado.meInteresa")), 1)
                      ]),
                      _: 1
                    }, 8, ["to"])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _hoisted_81,
    (_ctx.token && !_ctx.inscripcionesAbiertas)
      ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
          _createElementVNode("h3", _hoisted_83, _toDisplayString(_ctx.i18n("servicioColectivoEspacioPublicoNoDisponible")), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.inscripcionesAbiertas)
      ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
          _createElementVNode("div", _hoisted_85, [
            _createElementVNode("div", _hoisted_86, [
              _createElementVNode("h3", _hoisted_87, [
                _hoisted_88,
                _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.i18n("informacionGeneral")), 1)
              ]),
              _createElementVNode("p", _hoisted_90, _toDisplayString(_ctx.i18n("planCorresponsablesInfo")), 1),
              _createElementVNode("p", _hoisted_91, _toDisplayString(_ctx.i18n("planCorresponsablesObjetivos")), 1)
            ])
          ], 512)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}